// import { createBrowserRouter } from "react-router-dom";
// // import Layout from "../Layout/Layout";
// import Home from "../Pages/Home/Home";
// import About from "../Pages/About/About";
// import Login from "../Pages/SignUp/Login";
// import UserProfile from "../Pages/User/Profile/UserProfile";
// import AdminDash from "../Pages/Admin/AdminDash";
// import Services from "../Pages/Admin/Services";
// import UserDetails from "../Pages/Admin/User/UserDetails";
// import HomeClean from "../Pages/Services/HomeClean/HomeClean";
// import Electrician from "../Pages/Services/Electrician/Electrician";
// import Plumber from "../Pages/Services/Plumber/Plumber";
// import Servitor from "../Pages/Servitor/ServitorSite";
// import ServitorDetails from "../Pages/Admin/Servitor/ServitorDetails";
// import UserOrders from "../Pages/Admin/User/UserOrders";
// import ServitorConfirmOrders from "../Pages/Admin/Servitor/ServitorConfirmOrders";
// import AcceptedOrders from "../Pages/Servitor/AcceptedOrders";
// import ServitorSiteLayoutWrapper from "../Pages/Servitor/NavbarLayout/ServitorSiteLayoutWrapper";
// import ServitorProfile from "../Pages/Servitor/Profile/ServitorProfile";
// import CompleteOrders from "../Pages/Servitor/CompleteOrders";
// import Report from "../Pages/Admin/Report/Report";
// import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
// import NotificationsPage from "../Pages/User/Notification/NotificationsPage";
// import ServitorNotificationPage from "../Pages/Servitor/ServitorNotification/ServitorNotificationPage";
// import OrderHistory from "../Pages/User/Profile/OrderHistory";
// import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";
// import ChangePassword from "../Pages/User/Profile/ChangePassword";
// import ViewOrderDetails from "../Pages/Servitor/ViewOrderDetails";

// // import ServitorDashboard from "../Pages/Servitor/ServitorDashboard";

// // import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//     children: [
//       {
//         path: "home",
//         element: <Home />,
//       },
//     ],
//   },
//   {
//     path: "about",
//     element: <About />,
//   },
//   {
//     path: "services/home-cleaning",
//     element: <HomeClean />,
//   },
//   {
//     path: "services/electrician",
//     element: <Electrician />,
//   },
//   {
//     path: "services/plumber",
//     element: <Plumber />,
//   },
//   {
//     path: "login",
//     element: <Login />,
//   },
//   {
//     path: "profile",
//     element: <UserProfile />,
//     children: [
//       // (Optional) Default Profile Info view – you can put your personal info or edit form here
//       // { index: true, element: <div>Your Profile Home</div> },
//       // **CHANGE HERE:** Order History and Order Details are now separate routes.
//       { path: "changePassword", element: <ChangePassword /> },
//       { path: "orderhistory", element: <OrderHistory /> },
//       { path: "orderhistory/:orderId", element: <OrderDetailsView /> },
//       { path: "notifications", element: <NotificationsPage /> },
//       // You can add additional children like changePassword, etc.
//     ],
//   },
//   // {
//   //   path: "orderhistory",
//   //   element: <OrderHistory />,
//   // },
//   // {
//   //   path: "orderhistory/:orderId",
//   //   element: <OrderDetailsView />,
//   // },
//   // {
//   //   path: "notifications",
//   //   element: <NotificationsPage />,
//   // },
//   // {
//   //     path: 'profile/orderdetails',
//   //     element: <OrderDetailsView />
//   // },
//   {
//     path: "admin",
//     element: <AdminDash />,
//     children: [
//       {
//         path: "dashboard",
//         element: <Dashboard />,
//       },
//       {
//         path: "services",
//         element: <Services />,
//       },
//       {
//         path: "userdetails",
//         element: <UserDetails />,
//       },
//       {
//         path: "userorders",
//         element: <UserOrders />,
//       },
//       {
//         path: "servitordetails",
//         element: <ServitorDetails />,
//       },
//       {
//         path: "servitorconfirmorders",
//         element: <ServitorConfirmOrders />,
//       },
//       {
//         path: "reports",
//         element: <Report />,
//       },
//     ],
//   },
//   {
//     path: "servitor",
//     element: <ServitorSiteLayoutWrapper />,
//     children: [
//       { index: true, element: <Servitor /> },
//       // {
//       //   path: "dashboard",
//       //   element: <ServitorDashboard />,
//       // },
//       {
//         path: "accepted-orders",
//         element: <AcceptedOrders />,
//       },
//       {
//         path: "servitor-profile",
//         element: <ServitorProfile />,
//       },
//       {
//         path: "complete-orders",
//         element: <CompleteOrders />,
//       },
//       {
//         path: "notifications",
//         element: <ServitorNotificationPage />,
//       },

//       {
//         path: "orders/:orderNumber",
//         element: <ViewOrderDetails />,
//       },

//     ],
//   },
// ]);

// export default router;






// import { createBrowserRouter } from "react-router-dom";
// // import Layout from "../Layout/Layout";
// import Home from "../Pages/Home/Home";
// import About from "../Pages/About/About";
// import Login from "../Pages/SignUp/Login";
// import AdminLogin from "../Pages/SignUp/AdminLogin";
// import UserProfile from "../Pages/User/Profile/UserProfile";
// import AdminDash from "../Pages/Admin/AdminDash";
// import Services from "../Pages/Admin/Services";
// import UserDetails from "../Pages/Admin/User/UserDetails";
// import HomeClean from "../Pages/Services/HomeClean/HomeClean";
// import Electrician from "../Pages/Services/Electrician/Electrician";
// import Plumber from "../Pages/Services/Plumber/Plumber";
// import GasChula from "../Pages/Services/GasChula/GasChula";
// import AcService from "../Pages/Services/AcService/AcService";
// import FilterService from "../Pages/Services/FilterService/FilterService";
// import TutorService from "../Pages/Services/Tutorservice/TutorService";

// import Servitor from "../Pages/Servitor/ServitorSite";
// import ServitorDetails from "../Pages/Admin/Servitor/ServitorDetails";
// import UserOrders from "../Pages/Admin/User/UserOrders";
// import ServitorConfirmOrders from "../Pages/Admin/Servitor/ServitorConfirmOrders";
// import AcceptedOrders from "../Pages/Servitor/AcceptedOrders";
// import ServitorRechargeHistory from "../Pages/Servitor/ServitorRechargeHistory";
// import ServitorSiteLayoutWrapper from "../Pages/Servitor/NavbarLayout/ServitorSiteLayoutWrapper";
// import ServitorProfile from "../Pages/Servitor/Profile/ServitorProfile";
// import ServitorRewards from "../Pages/Servitor/ServitorRewards";
// import CompleteOrders from "../Pages/Servitor/CompleteOrders";
// import Report from "../Pages/Admin/Report/Report";
// import FinanceReport from "../Pages/Admin/Report/FinanceReport";
// import AmountRecharges from "../Pages/Admin/Report/AmountRecharge";
// import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
// import NotificationsPage from "../Pages/User/Notification/NotificationsPage";
// import ServitorNotificationPage from "../Pages/Servitor/ServitorNotification/ServitorNotificationPage";
// import OrderHistory from "../Pages/User/Profile/OrderHistory";
// import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";
// import ChangePassword from "../Pages/User/Profile/ChangePassword";
// import UserRewards from "../Pages/User/Profile/UserRewards";
// import ViewOrderDetails from "../Pages/Servitor/ViewOrderDetails";
// import ProtectedRoute from "../Components/ProtectedRoute/ProtectedRoute";
// // import PublicRoute from "../Components/ProtectedRoute/PublicRoute";

// import ServitorFeedbackList from "../Pages/Admin/Servitor/ServitorFeedbackList";
// import ServitorOrderHistory from "../Pages/Admin/Servitor/ServitorOrderHistory";
// import ServitorOrderHistoryDetails from "../Pages/Admin/Servitor/ServitorOrderHistoryDetails";
// import Locations from "../Pages/Admin/Location/Locations";
// import ServitorSignup from "../Pages/SignUp/ServitorSignup";
// import StartEarningPage from "../Pages/StartEarningPage/StartEarningPage";
// import FaqPage from "../Pages/FAQ/FaqPage";
// import TermsPrivacy from "../Pages/TermsPolicy/TermsPrivacy";
// import ServitorTransactionHistory from "../Pages/Servitor/ServitorTransactionHistory";
// import ContactPage from "../Pages/Contact/ContactPage";
// import AdminPlaceOrder from "../Pages/Admin/User/AdminPlaceOrder";
// import ReportIssue from "../Pages/User/Profile/ReportIssue";
// import ServitorReportIssue from "../Pages/Servitor/Profile/helpReport/ServitorReportIssue";
// import AdminReports from "../Pages/Admin/SupportReport/AdminReports";
// import ServitorReferralRewards from "../Pages/Servitor/Profile/ReferralRewards/ServitorReferralRewards";
// import ServitorReferral from "../Pages/Admin/Servitor/ServitorReferral";
// import ServitorReferralDetails from "../Pages/Admin/Servitor/ServitorReferralDetails";
// import ContactList from "../Pages/Admin/ContactUs/ContactList";
// import ServitorAgreement from "../Pages/ServitorAgreement/ServitorAgreement";
// import FullBuildingService from "../Pages/FullBuilding/FullBuildingService";
// import AdminFullBuilding from "../Pages/Admin/Fullbuilding/AdminFullBuilding";
// import Admins from "../Pages/Admin/Admins";
// import AdminActivity from "../Pages/Admin/AdminActivity/AdminActivity";

// // import ServitorDashboard from "../Pages/Servitor/ServitorDashboard";

// // import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//     children: [
//       {
//         path: "home",
//         element: <Home />,
//       },
//     ],
//   },
//   {
//     path: "about",
//     element: <About />,
//   },
//   {
//     path: "earnwithHelpNao",
//     element: <StartEarningPage />,
//   },
//   {
//     path: "services/full-building",
//     element: <FullBuildingService />,
//   },

//   {
//     path: "contact",
//     element: <ContactPage />,
//   },
//   {
//     path: "helpfaqs",
//     element: <FaqPage />,
//   },
//   {
//     path: "/legal/terms-and-privacy",
//     element: <TermsPrivacy />,
//   },
//   {
//     path: "/servitor-agreement",
//     element: <ServitorAgreement />,
//   },
//   {
//     path: "services/home-cleaning",
//     element: <HomeClean />,
//   },
//   {
//     path: "services/electrician",
//     element: <Electrician />,
//   },
//   {
//     path: "services/plumber",
//     element: <Plumber />,
//   },
//   {
//     path: "services/gas-chula",
//     element: <GasChula />,
//   },
//   {
//     path: "services/ac-service",
//     element: <AcService />,
//   },
//   {
//     path: "services/filter",
//     element: <FilterService />,
//   },
//   {
//     path: "services/tutor-service",
//     element: <TutorService />,
//   },
//   {
//     path: "login",
//     element: <Login />,
//   },

//   // For protected
//   // {
//   //   path: "login",
//   //   // element: <Login />,
//   //   element: (
//   //     <PublicRoute>
//   //       <Login />
//   //     </PublicRoute>
//   //   ),
//   // },

//   {
//     path: "signup/servitor",
//     element: <ServitorSignup />,
//   },

//   {
//     path: "HelpNaoadminpannel/login",
//     element: <AdminLogin />,
//   },

//   {
//     path: "profile",
//     element: (
//       <ProtectedRoute type="user">
//         <UserProfile />
//       </ProtectedRoute>
//     ),
//     children: [
//       { path: "changePassword", element: <ChangePassword /> },
//       { path: "orderhistory", element: <OrderHistory /> },
//       { path: "orderhistory/:orderId", element: <OrderDetailsView /> },
//       { path: "notifications", element: <NotificationsPage /> },
//       { path: "rewards", element: <UserRewards /> },
//       { path: "support/report/:orderNumber", element: <ReportIssue /> },
//     ],
//   },
//   // {
//   //   path: "orderhistory",
//   //   element: <OrderHistory />,
//   // },
//   // {
//   //   path: "orderhistory/:orderId",
//   //   element: <OrderDetailsView />,
//   // },
//   // {
//   //   path: "notifications",
//   //   element: <NotificationsPage />,
//   // },
//   // {
//   //     path: 'profile/orderdetails',
//   //     element: <OrderDetailsView />
//   // },
//   {
//     path: "admin",
//     element: (
//       <ProtectedRoute type="admin">
//         <AdminDash />
//       </ProtectedRoute>
//     ),
//     children: [
//       {
//         path: "dashboard",
//         element: <Dashboard />,
//       },
//       {
//         path: "helpnaoadmins",
//         element: <Admins />,
//       },
//       {
//         path: "helpnaoadmins/adminactivity",
//         element: <AdminActivity />,
//       },
//       {
//         path: "services",
//         element: <Services />,
//       },
//       {
//         path: "location",
//         element: <Locations />,
//       },
//       {
//         path: "userdetails",
//         element: <UserDetails />,
//       },
//       {
//         path: "placeordersforuser",
//         element: <AdminPlaceOrder />,
//       },
//       {
//         path: "userorders",
//         element: <UserOrders />,
//       },
//       {
//         path: "servitordetails",
//         element: <ServitorDetails />,
//       },
//       {
//         path: "servitorconfirmorders",
//         element: <ServitorConfirmOrders />,
//       },
//       {
//         path: "servitorfeedbackdetails",
//         element: <ServitorFeedbackList />,
//       },
//       {
//         path: "servitor-referral",
//         element: <ServitorReferral />,
//       },
//       {
//         path: "servitor-referral/:id",
//         element: <ServitorReferralDetails />, // details page
//       },
//       {
//         path: "servitororderhistory",
//         element: <ServitorOrderHistory />,
//       },
//       {
//         path: "servitororderhistory/:servitorId",
//         element: <ServitorOrderHistoryDetails />,
//       },
//       {
//         path: "full-building-requests",
//         element: <AdminFullBuilding />,
//       },
//       {
//         path: "reports",
//         element: <Report />,
//       },
//       {
//         path: "reports/financereport",
//         element: <FinanceReport />,
//       },
//       {
//         path: "reports/rechargeamount",
//         element: <AmountRecharges />,
//       },
//       {
//         path: "helpsupport/reports",
//         element: <AdminReports />,
//       },
//       {
//         path: "helpsupport/contactuslist",
//         element: <ContactList />,
//       },
//     ],
//   },
//   {
//     path: "servitor",
//     element: (
//       <ProtectedRoute type="servitor">
//         <ServitorSiteLayoutWrapper />
//       </ProtectedRoute>
//     ),
//     children: [
//       { index: true, element: <Servitor /> },
//       // {
//       //   path: "dashboard",
//       //   element: <ServitorDashboard />,
//       // },
//       {
//         path: "accepted-orders",
//         element: <AcceptedOrders />,
//       },
//       {
//         path: "servitor-profile",
//         element: <ServitorProfile />,
//       },
//       {
//         path: "complete-orders",
//         element: <CompleteOrders />,
//       },
//       {
//         path: "recharge-history",
//         element: <ServitorRechargeHistory />,
//       },
//       {
//         path: "transaction-history",
//         element: <ServitorTransactionHistory />,
//       },
//       {
//         path: "servitor-rewards",
//         element: <ServitorRewards />,
//       },
//       {
//         path: "notifications",
//         element: <ServitorNotificationPage />,
//       },

//       { path: "support/report/:orderNumber", element: <ServitorReportIssue /> },

//       {
//         path: "servitor-refrewards",
//         element: <ServitorReferralRewards />,
//       },

//       {
//         path: "orders/:orderNumber",
//         element: <ViewOrderDetails />,
//       },
//     ],
//   },
// ]);

// export default router;






// ***** upper route is okay, But Updated with protected all routes (10-dec-2025) ***** //
import { createBrowserRouter, Navigate } from "react-router-dom";
// import Layout from "../Layout/Layout";
import Home from "../Pages/Home/Home";
import About from "../Pages/About/About";
import Login from "../Pages/SignUp/Login";
import AdminLogin from "../Pages/SignUp/AdminLogin";
import UserProfile from "../Pages/User/Profile/UserProfile";
import AdminDash from "../Pages/Admin/AdminDash";
import Services from "../Pages/Admin/Services";
import UserDetails from "../Pages/Admin/User/UserDetails";
import HomeClean from "../Pages/Services/HomeClean/HomeClean";
import Electrician from "../Pages/Services/Electrician/Electrician";
import Plumber from "../Pages/Services/Plumber/Plumber";
import GasChula from "../Pages/Services/GasChula/GasChula";
import AcService from "../Pages/Services/AcService/AcService";
import FilterService from "../Pages/Services/FilterService/FilterService";
import TutorService from "../Pages/Services/Tutorservice/TutorService";

import Servitor from "../Pages/Servitor/ServitorSite";
import ServitorDetails from "../Pages/Admin/Servitor/ServitorDetails";
import UserOrders from "../Pages/Admin/User/UserOrders";
import ServitorConfirmOrders from "../Pages/Admin/Servitor/ServitorConfirmOrders";
import AcceptedOrders from "../Pages/Servitor/AcceptedOrders";
import ServitorRechargeHistory from "../Pages/Servitor/ServitorRechargeHistory";
import ServitorSiteLayoutWrapper from "../Pages/Servitor/NavbarLayout/ServitorSiteLayoutWrapper";
import ServitorProfile from "../Pages/Servitor/Profile/ServitorProfile";
import ServitorRewards from "../Pages/Servitor/ServitorRewards";
import CompleteOrders from "../Pages/Servitor/CompleteOrders";
import Report from "../Pages/Admin/Report/Report";
import FinanceReport from "../Pages/Admin/Report/FinanceReport";
import AmountRecharges from "../Pages/Admin/Report/AmountRecharge";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import NotificationsPage from "../Pages/User/Notification/NotificationsPage";
import ServitorNotificationPage from "../Pages/Servitor/ServitorNotification/ServitorNotificationPage";
import OrderHistory from "../Pages/User/Profile/OrderHistory";
import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";
import ChangePassword from "../Pages/User/Profile/ChangePassword";
import UserRewards from "../Pages/User/Profile/UserRewards";
import ViewOrderDetails from "../Pages/Servitor/ViewOrderDetails";
import ProtectedRoute from "../Components/ProtectedRoute/ProtectedRoute";
import PublicRoute from "../Components/ProtectedRoute/PublicRoute";

import ServitorFeedbackList from "../Pages/Admin/Servitor/ServitorFeedbackList";
import ServitorOrderHistory from "../Pages/Admin/Servitor/ServitorOrderHistory";
import ServitorOrderHistoryDetails from "../Pages/Admin/Servitor/ServitorOrderHistoryDetails";
import Locations from "../Pages/Admin/Location/Locations";
import ServitorSignup from "../Pages/SignUp/ServitorSignup";
import StartEarningPage from "../Pages/StartEarningPage/StartEarningPage";
import FaqPage from "../Pages/FAQ/FaqPage";
import TermsPrivacy from "../Pages/TermsPolicy/TermsPrivacy";
import ServitorTransactionHistory from "../Pages/Servitor/ServitorTransactionHistory";
import ContactPage from "../Pages/Contact/ContactPage";
import AdminPlaceOrder from "../Pages/Admin/User/AdminPlaceOrder";
import ReportIssue from "../Pages/User/Profile/ReportIssue";
import ServitorReportIssue from "../Pages/Servitor/Profile/helpReport/ServitorReportIssue";
import AdminReports from "../Pages/Admin/SupportReport/AdminReports";
import ServitorReferralRewards from "../Pages/Servitor/Profile/ReferralRewards/ServitorReferralRewards";
import ServitorReferral from "../Pages/Admin/Servitor/ServitorReferral";
import ServitorReferralDetails from "../Pages/Admin/Servitor/ServitorReferralDetails";
import ContactList from "../Pages/Admin/ContactUs/ContactList";
import ServitorAgreement from "../Pages/ServitorAgreement/ServitorAgreement";
import FullBuildingService from "../Pages/FullBuilding/FullBuildingService";
import AdminFullBuilding from "../Pages/Admin/Fullbuilding/AdminFullBuilding";
import Admins from "../Pages/Admin/Admins";
import AdminActivity from "../Pages/Admin/AdminActivity/AdminActivity";
import AdminNotifications from "../Pages/Admin/Report/AdminNotifications";

// import ServitorDashboard from "../Pages/Servitor/ServitorDashboard";

// import OrderDetailsView from "../Pages/User/Profile/OrderDetailsView";

const router = createBrowserRouter([
  {
    path: "/",
    // element: <Home />,
    element: (
      <PublicRoute>
        <Home />
      </PublicRoute>
    ),
    // children: [
    //   {
    //     path: "home",
    //     // element: <Home />,
    //     // element: (
    //     //   <PublicRoute>
    //     //     <Home />
    //     //   </PublicRoute>
    //     // ),
    //     element: <Navigate to="/" replace />,
    //   },
    // ],
  },
  {
    path: "/home",
    element: <Navigate to="/" replace />,
  },
  {
    path: "about",
    // element: <About />,
    element: (
      <PublicRoute>
        <About />
      </PublicRoute>
    ),

  },
  {
    path: "earnwithHelpNao",
    // element: <StartEarningPage />,

element: (
      <PublicRoute>
        <StartEarningPage />
      </PublicRoute>
    ),  },
  {
    path: "services/full-building",
    // element: <FullBuildingService />,
    element: (
      <PublicRoute>
        <FullBuildingService />
      </PublicRoute>
    ),
  },

  {
    path: "contact",
    // element: <ContactPage />,
    element: (
      <PublicRoute>
        <ContactPage />
      </PublicRoute>
    ),
  },
  {
    path: "helpfaqs",
    // element: <FaqPage />,
    element: (
      <PublicRoute>
        <FaqPage />
      </PublicRoute>
    ),
  },
  {
    path: "/legal/terms-and-privacy",
    // element: <TermsPrivacy />,
    element: (
      <PublicRoute>
        <TermsPrivacy />
      </PublicRoute>
    ),
  },
  {
    path: "/servitor-agreement",
    // element: <ServitorAgreement />,
    element: (
      <PublicRoute>
        <ServitorAgreement />
      </PublicRoute>
    ),
  },
  {
    path: "services/home-cleaning",
    // element: <HomeClean />,
    element: (
      <PublicRoute>
        <HomeClean />
      </PublicRoute>
    ),
  },
  {
    path: "services/electrician",
    // element: <Electrician />,
    element: (
      <PublicRoute>
        <Electrician />
      </PublicRoute>
    ),
  },
  {
    path: "services/plumber",
    // element: <Plumber />,
    element: (
      <PublicRoute>
        <Plumber />
      </PublicRoute>
    ),
  },
  {
    path: "services/gas-chula",
    // element: <GasChula />,
    element: (
      <PublicRoute>
        <GasChula />
      </PublicRoute>
    ),
  },
  {
    path: "services/ac-service",
    // element: <AcService />,
    element: (
      <PublicRoute>
        <AcService />
      </PublicRoute>
    ),
  },
  {
    path: "services/filter",
    // element: <FilterService />,
    element: (
      <PublicRoute>
        <FilterService />
      </PublicRoute>
    ),
  },
  {
    path: "services/tutor-service",
    // element: <TutorService />,
    element: (
      <PublicRoute>
        <TutorService />
      </PublicRoute>
    ),
  },
  {
    path: "login",
    // element: <Login />,
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },

  // For protected
  // {
  //   path: "login",
  //   // element: <Login />,
  //   element: (
  //     <PublicRoute>
  //       <Login />
  //     </PublicRoute>
  //   ),
  // },

  {
    path: "signup/servitor",
    // element: <ServitorSignup />,
    element: (
      <PublicRoute>
        <ServitorSignup />
      </PublicRoute>
    ),
  },

  {
    path: "HelpNaoadminpannel/login",
    // element: <AdminLogin />,
    element: (
      <PublicRoute>
        <AdminLogin />
      </PublicRoute>
    ),
  },

  {
    path: "profile",
    element: (
      <ProtectedRoute type="user">
        <UserProfile />
      </ProtectedRoute>
    ),
    children: [
      { path: "changePassword", element: <ChangePassword /> },
      { path: "orderhistory", element: <OrderHistory /> },
      { path: "orderhistory/:orderId", element: <OrderDetailsView /> },
      { path: "notifications", element: <NotificationsPage /> },
      { path: "rewards", element: <UserRewards /> },
      { path: "support/report/:orderNumber", element: <ReportIssue /> },
    ],
  },
  // {
  //   path: "orderhistory",
  //   element: <OrderHistory />,
  // },
  // {
  //   path: "orderhistory/:orderId",
  //   element: <OrderDetailsView />,
  // },
  // {
  //   path: "notifications",
  //   element: <NotificationsPage />,
  // },
  // {
  //     path: 'profile/orderdetails',
  //     element: <OrderDetailsView />
  // },
  {
    path: "admin",
    element: (
      <ProtectedRoute type="admin">
        <AdminDash />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "helpnaoadmins",
        element: <Admins />,
      },
      {
        path: "helpnaoadmins/adminactivity",
        element: <AdminActivity />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "location",
        element: <Locations />,
      },
      {
        path: "userdetails",
        element: <UserDetails />,
      },
      {
        path: "placeordersforuser",
        element: <AdminPlaceOrder />,
      },
      {
        path: "userorders",
        element: <UserOrders />,
      },
      {
        path: "servitordetails",
        element: <ServitorDetails />,
      },
      {
        path: "servitorconfirmorders",
        element: <ServitorConfirmOrders />,
      },
      {
        path: "servitorfeedbackdetails",
        element: <ServitorFeedbackList />,
      },
      {
        path: "servitor-referral",
        element: <ServitorReferral />,
      },
      {
        path: "servitor-referral/:id",
        element: <ServitorReferralDetails />, // details page
      },
      {
        path: "servitororderhistory",
        element: <ServitorOrderHistory />,
      },
      {
        path: "servitororderhistory/:servitorId",
        element: <ServitorOrderHistoryDetails />,
      },
      {
        path: "full-building-requests",
        element: <AdminFullBuilding />,
      },
      {
        path: "reports",
        element: <Report />,
      },
      {
        path: "reports/financereport",
        element: <FinanceReport />,
      },
      {
        path: "reports/rechargeamount",
        element: <AmountRecharges />,
      },
      {
        path: "checkreports/notifications-all",
        element: <AdminNotifications />,
      },
      {
        path: "helpsupport/reports",
        element: <AdminReports />,
      },
      {
        path: "helpsupport/contactuslist",
        element: <ContactList />,
      },
    ],
  },
  {
    path: "servitor",
    element: (
      <ProtectedRoute type="servitor">
        <ServitorSiteLayoutWrapper />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Servitor /> },
      // {
      //   path: "dashboard",
      //   element: <ServitorDashboard />,
      // },
      {
        path: "accepted-orders",
        element: <AcceptedOrders />,
      },
      {
        path: "servitor-profile",
        element: <ServitorProfile />,
      },
      {
        path: "complete-orders",
        element: <CompleteOrders />,
      },
      {
        path: "recharge-history",
        element: <ServitorRechargeHistory />,
      },
      {
        path: "transaction-history",
        element: <ServitorTransactionHistory />,
      },
      {
        path: "servitor-rewards",
        element: <ServitorRewards />,
      },
      {
        path: "notifications",
        element: <ServitorNotificationPage />,
      },

      { path: "support/report/:orderNumber", element: <ServitorReportIssue /> },

      {
        path: "servitor-refrewards",
        element: <ServitorReferralRewards />,
      },

      {
        path: "orders/:orderNumber",
        element: <ViewOrderDetails />,
      },
    ],
  },
]);

export default router;